import { ChannelActionButton } from './ChannelActionButton';
import { ChannelImage } from './ChannelImage';
import { ChannelImageEditor } from './ChannelImageEditor';
import { formatFollowersCount } from '../utils/channelText';

const IMAGE_SIZE = 64;

interface ChannelHeaderInfoProps {
  channel: {
    id: string;
    name: string;
    description?: string | null;
    image?: string | null;
    updatedAt?: string | null;
    followersCount: number;
    viewerIsOwner: boolean;
    viewerIsFollowing: boolean;
  };
}

// The identity block at the top of a channel's page: image (editable by the
// owner) next to the name, optional
// description (secondary typography), a follower count and the primary action
// (Editar for the owner, Seguir/Dejar de seguir otherwise).
export const ChannelHeaderInfo = ({ channel }: ChannelHeaderInfoProps) => {
  const followersLabel = formatFollowersCount(channel.followersCount);

  return (
    <div className="flex flex-col gap-2 mb-4">
      <div className="flex items-center gap-3">
        {channel.viewerIsOwner ? (
          <ChannelImageEditor
            channelId={channel.id}
            image={channel.image}
            updatedAt={channel.updatedAt}
            name={channel.name}
            size={IMAGE_SIZE}
          />
        ) : (
          <ChannelImage
            image={channel.image}
            updatedAt={channel.updatedAt}
            name={channel.name}
            size={IMAGE_SIZE}
          />
        )}
        <h1 className="text-xl font-bold text-gray-900 dark:text-gray-100 m-0 min-w-0 break-words">
          {channel.name}
        </h1>
      </div>

      {channel.description && (
        <p className="text-sm text-gray-500 dark:text-gray-400 m-0 whitespace-pre-line">
          {channel.description}
        </p>
      )}

      <div className="flex items-center justify-between gap-4">
        <span className="text-sm text-gray-500 dark:text-gray-400">{followersLabel}</span>
        <ChannelActionButton
          channelId={channel.id}
          viewerIsOwner={channel.viewerIsOwner}
          viewerIsFollowing={channel.viewerIsFollowing}
        />
      </div>
    </div>
  );
};
